module.exports = __webpack_public_path__ + "img/ezilly-logo.fee69aff.png";